import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ListTodo, Mic, Settings, ShieldCheck, Terminal } from 'lucide-react';

const BottomNav = ({ showAdmin = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  // Determine current tab from pathname
  const getCurrentTab = () => {
    if (location.pathname.startsWith('/record')) return 'record';
    if (location.pathname.startsWith('/inspections')) return 'reports';
    if (location.pathname.startsWith('/settings')) return 'settings';
    if (location.pathname.startsWith('/admin')) return 'admin';
    if (location.pathname.startsWith('/debug')) return 'debug';
    return 'reports'; // Default: / is list view
  };

  const currentTab = getCurrentTab();

  const navItems = [
    { id: 'record', label: t('nav.record'), icon: Mic, path: '/record' },
    { id: 'reports', label: t('nav.reports'), icon: ListTodo, path: '/' },
    { id: 'settings', label: t('nav.settings'), icon: Settings, path: '/settings' },
  ];

  // Add admin and debug tabs if user is admin
  if (showAdmin) {
    navItems.push({ id: 'admin', label: t('nav.admin'), icon: ShieldCheck, path: '/admin' });
    navItems.push({ id: 'debug', label: t('nav.debug'), icon: Terminal, path: '/debug' });
  }

  return (
    <nav className="bottom-nav">
      {navItems.map((item) => {
        const Icon = item.icon;
        const isActive = currentTab === item.id;

        return (
          <button
            key={item.id}
            onClick={() => navigate(item.path)}
            className={`bottom-nav-item ${isActive ? 'active' : ''}`}
            aria-label={item.label}
            aria-current={isActive ? 'page' : undefined}
          >
            <Icon size={24} strokeWidth={isActive ? 2.5 : 2} />
            <span>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNav;
